var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayMarketLabelWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 64,
    viewBox: "0 0 274 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 64,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1392_13090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5903 16.2064C68.2193 16.6006 68 17.2124 68 18.0048V46.3132C68 47.1068 68.2193 47.7174 68.5903 48.1116L68.6847 48.2038L84.4809 32.3459V32.159V31.9721L68.6847 16.1129L68.5903 16.2064Z",
    fill: "url(#paint0_linear_1392_13090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7453 37.6334L84.4807 32.3457V32.1588V31.9719L89.7466 26.6855L89.8651 26.7534L96.1038 30.3118C97.885 31.3281 97.885 32.9908 96.1038 34.0084L89.8651 37.5668L89.7453 37.6334Z",
    fill: "url(#paint1_linear_1392_13090)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1392_13090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8654 37.5654L84.4797 32.1587L68.5903 48.1113C69.1768 48.736 70.1471 48.8128 71.2398 48.1907L89.8654 37.5654Z",
    fill: "url(#paint2_linear_1392_13090)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.8654 26.7523L71.2398 16.1283C70.1471 15.5049 69.1768 15.583 68.5903 16.2077L84.4809 32.1603L89.8654 26.7523Z",
    fill: "url(#paint3_linear_1392_13090)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.503 33.7078C134.671 33.7078 132.363 35.8611 132.363 38.8267C132.363 41.7744 134.671 43.9457 137.503 43.9457C140.337 43.9457 142.645 41.7744 142.645 38.8267C142.644 35.8611 140.336 33.7078 137.503 33.7078ZM137.503 41.9308C135.951 41.9308 134.613 40.6514 134.613 38.8279C134.613 36.9852 135.952 35.725 137.503 35.725C139.056 35.725 140.394 36.9852 140.394 38.8279C140.394 40.6502 139.056 41.9308 137.503 41.9308ZM126.287 33.7078C123.455 33.7078 121.147 35.8611 121.147 38.8267C121.147 41.7744 123.455 43.9457 126.287 43.9457C129.121 43.9457 131.429 41.7744 131.429 38.8267C131.429 35.8611 129.121 33.7078 126.287 33.7078ZM126.287 41.9308C124.735 41.9308 123.397 40.6514 123.397 38.8279C123.397 36.9852 124.736 35.725 126.287 35.725C127.84 35.725 129.177 36.9852 129.177 38.8279C129.179 40.6502 127.84 41.9308 126.287 41.9308ZM112.947 35.2797V37.451H118.147C117.991 38.6727 117.584 39.5646 116.963 40.1844C116.207 40.9403 115.023 41.7744 112.947 41.7744C109.746 41.7744 107.244 39.195 107.244 35.9959C107.244 32.7967 109.746 30.2173 112.947 30.2173C114.674 30.2173 115.935 30.8962 116.866 31.7688L118.399 30.2366C117.098 28.9957 115.372 28.046 112.947 28.046C108.562 28.046 104.876 31.6135 104.876 35.9959C104.876 40.3782 108.562 43.9457 112.947 43.9457C115.313 43.9457 117.099 43.1694 118.495 41.7154C119.93 40.2807 120.377 38.2634 120.377 36.635C120.377 36.1319 120.338 35.6661 120.26 35.2785L112.947 35.2797ZM167.508 36.966C167.081 35.8225 165.781 33.7078 163.123 33.7078C160.485 33.7078 158.292 35.7828 158.292 38.8267C158.292 41.6961 160.465 43.9457 163.375 43.9457C165.722 43.9457 167.08 42.511 167.644 41.6769L165.898 40.513C165.316 41.3664 164.52 41.9284 163.375 41.9284C162.231 41.9284 161.416 41.4049 160.892 40.377L167.74 37.5461L167.508 36.966ZM160.523 38.6727C160.465 36.6939 162.056 35.6865 163.201 35.6865C164.094 35.6865 164.85 36.1331 165.103 36.7722L160.523 38.6727ZM154.956 43.6364H157.206V28.5901H154.956V43.6364ZM151.269 34.8524H151.192C150.687 34.2506 149.717 33.7078 148.496 33.7078C145.934 33.7078 143.587 35.9573 143.587 38.8472C143.587 41.7166 145.934 43.9469 148.496 43.9469C149.718 43.9469 150.687 43.4041 151.192 42.7842H151.269V43.5208C151.269 45.4791 150.221 46.5262 148.534 46.5262C147.156 46.5262 146.303 45.5381 145.953 44.704L143.994 45.5188C144.557 46.8753 146.05 48.5435 148.534 48.5435C151.172 48.5435 153.404 46.992 153.404 43.2103V34.0195H151.27L151.269 34.8524ZM148.689 41.9308C147.137 41.9308 145.838 40.6309 145.838 38.8472C145.838 37.043 147.137 35.725 148.689 35.725C150.221 35.725 151.424 37.043 151.424 38.8472C151.424 40.6309 150.221 41.9308 148.689 41.9308ZM178.049 28.5901H172.665V43.6364H174.911V37.9361H178.048C180.539 37.9361 182.988 36.1343 182.988 33.2637C182.988 30.3931 180.54 28.5901 178.049 28.5901ZM178.107 35.8418H174.911V30.6843H178.107C179.787 30.6843 180.741 32.0745 180.741 33.2637C180.741 34.4288 179.787 35.8418 178.107 35.8418ZM191.994 33.6813C190.367 33.6813 188.683 34.3975 187.985 35.985L189.98 36.8167C190.406 35.985 191.201 35.713 192.033 35.713C193.195 35.713 194.376 36.4099 194.395 37.6484V37.8037C193.988 37.5714 193.117 37.2235 192.052 37.2235C189.903 37.2235 187.713 38.4043 187.713 40.6105C187.713 42.6241 189.476 43.9204 191.451 43.9204C192.961 43.9204 193.795 43.2428 194.317 42.4484H194.394V43.6099H196.564V37.841C196.565 35.1714 194.569 33.6813 191.994 33.6813ZM191.722 41.9272C190.988 41.9272 189.96 41.5589 189.96 40.649C189.96 39.4875 191.239 39.0422 192.343 39.0422C193.33 39.0422 193.796 39.2552 194.395 39.5453C194.221 40.9403 193.02 41.9272 191.722 41.9272ZM204.466 34.0099L201.891 40.5335H201.813L199.14 34.0099H196.72L200.728 43.1272L198.443 48.1992H200.786L206.965 34.0099H204.466ZM184.228 43.6364H186.474V28.5901H184.228V43.6364Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.667 19.6903C112.667 20.6807 112.368 21.4689 111.77 22.0575C111.092 22.7571 110.206 23.1069 109.119 23.1069C108.077 23.1069 107.19 22.7524 106.462 22.0433C105.733 21.333 105.368 20.4538 105.368 19.4043C105.368 18.3537 105.733 17.4744 106.462 16.7654C107.19 16.0551 108.077 15.7006 109.119 15.7006C109.636 15.7006 110.13 15.7998 110.6 15.9972C111.07 16.1957 111.447 16.4593 111.728 16.789L111.094 17.413C110.616 16.8516 109.958 16.5715 109.117 16.5715C108.357 16.5715 107.7 16.8339 107.145 17.3586C106.591 17.8833 106.314 18.5652 106.314 19.4031C106.314 20.241 106.591 20.9229 107.145 21.4477C107.7 21.9724 108.357 22.2347 109.117 22.2347C109.923 22.2347 110.596 21.9712 111.134 21.4429C111.483 21.099 111.685 20.6204 111.739 20.007H109.117V19.155H112.615C112.651 19.3405 112.667 19.519 112.667 19.6903Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.213 16.7288H114.926V18.9766H117.891V19.8287H114.926V22.0764H118.213V22.9486H113.999V15.8578H118.213V16.7288Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.124 22.9486H121.197V16.7288H119.18V15.8578H124.141V16.7288H122.124V22.9486Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.73 22.9486V15.8578H128.657V22.9486H127.73Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.771 22.9486H131.844V16.7288H129.827V15.8578H134.788V16.7288H132.771V22.9486Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.178 22.0327C143.468 22.7489 142.586 23.107 141.531 23.107C140.476 23.107 139.594 22.7489 138.885 22.0327C138.175 21.3165 137.822 20.4396 137.822 19.4032C137.822 18.3668 138.175 17.4899 138.885 16.7737C139.594 16.0575 140.476 15.6982 141.531 15.6982C142.58 15.6982 143.461 16.0587 144.173 16.7784C144.885 17.4981 145.241 18.3727 145.241 19.4032C145.241 20.4396 144.887 21.3165 144.178 22.0327ZM139.57 21.4383C140.104 21.9701 140.757 22.2348 141.531 22.2348C142.305 22.2348 142.959 21.9689 143.492 21.4383C144.026 20.9064 144.295 20.2281 144.295 19.4032C144.295 18.5783 144.026 17.8999 143.492 17.3681C142.959 16.8363 142.305 16.5716 141.531 16.5716C140.757 16.5716 140.104 16.8375 139.57 17.3681C139.037 17.8999 138.769 18.5783 138.769 19.4032C138.769 20.2281 139.037 20.9064 139.57 21.4383Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.543 22.9486V15.8578H147.672L151.18 21.3733H151.22L151.18 20.0071V15.8578H152.108V22.9486H151.139L147.469 17.1649H147.429L147.469 18.531V22.9486H146.543Z",
    fill: "#212121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.667 19.6903C112.667 20.6807 112.368 21.4689 111.77 22.0575C111.092 22.7571 110.206 23.1069 109.119 23.1069C108.077 23.1069 107.19 22.7524 106.462 22.0433C105.733 21.333 105.368 20.4538 105.368 19.4043C105.368 18.3537 105.733 17.4744 106.462 16.7654C107.19 16.0551 108.077 15.7006 109.119 15.7006C109.636 15.7006 110.13 15.7998 110.6 15.9972C111.07 16.1957 111.447 16.4593 111.728 16.789L111.094 17.413C110.616 16.8516 109.958 16.5715 109.117 16.5715C108.357 16.5715 107.7 16.8339 107.145 17.3586C106.591 17.8833 106.314 18.5652 106.314 19.4031C106.314 20.241 106.591 20.9229 107.145 21.4477C107.7 21.9724 108.357 22.2347 109.117 22.2347C109.923 22.2347 110.596 21.9712 111.134 21.4429C111.483 21.099 111.685 20.6204 111.739 20.007H109.117V19.155H112.615C112.651 19.3405 112.667 19.519 112.667 19.6903Z",
    stroke: "#212121",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.213 16.7288H114.926V18.9766H117.891V19.8287H114.926V22.0764H118.213V22.9486H113.999V15.8578H118.213V16.7288Z",
    stroke: "#212121",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.124 22.9486H121.197V16.7288H119.18V15.8578H124.141V16.7288H122.124V22.9486Z",
    stroke: "#212121",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.73 22.9486V15.8578H128.657V22.9486H127.73Z",
    stroke: "#212121",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.771 22.9486H131.844V16.7288H129.827V15.8578H134.788V16.7288H132.771V22.9486Z",
    stroke: "#212121",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M144.178 22.0327C143.468 22.7489 142.586 23.107 141.531 23.107C140.476 23.107 139.594 22.7489 138.885 22.0327C138.175 21.3165 137.822 20.4396 137.822 19.4032C137.822 18.3668 138.175 17.4899 138.885 16.7737C139.594 16.0575 140.476 15.6982 141.531 15.6982C142.58 15.6982 143.461 16.0587 144.173 16.7784C144.885 17.4981 145.241 18.3727 145.241 19.4032C145.241 20.4396 144.887 21.3165 144.178 22.0327ZM139.57 21.4383C140.104 21.9701 140.757 22.2348 141.531 22.2348C142.305 22.2348 142.959 21.9689 143.492 21.4383C144.026 20.9064 144.295 20.2281 144.295 19.4032C144.295 18.5783 144.026 17.8999 143.492 17.3681C142.959 16.8363 142.305 16.5716 141.531 16.5716C140.757 16.5716 140.104 16.8375 139.57 17.3681C139.037 17.8999 138.769 18.5783 138.769 19.4032C138.769 20.2281 139.037 20.9064 139.57 21.4383Z",
    stroke: "#212121",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M146.543 22.9486V15.8578H147.672L151.18 21.3733H151.22L151.18 20.0071V15.8578H152.108V22.9486H151.139L147.469 17.1649H147.429L147.469 18.531V22.9486H146.543Z",
    stroke: "#212121",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1392_13090",
    x: 68,
    y: 15.6981,
    width: 29.4397,
    height: 32.9222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1392_13090"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1392_13090",
    result: "effect2_innerShadow_1392_13090"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1392_13090",
    x: 68.5903,
    y: 32.1587,
    width: 21.2751,
    height: 16.4617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1392_13090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1392_13090",
    x1: 83.0807,
    y1: 17.7052,
    x2: 61.5999,
    y2: 39.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1392_13090",
    x1: 98.4225,
    y1: 32.1588,
    x2: 67.5721,
    y2: 32.1588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1392_13090",
    x1: 86.9406,
    y1: 35.0949,
    x2: 57.8099,
    y2: 64.1123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1392_13090",
    x1: 64.5885,
    y1: 6.78404,
    x2: 77.5962,
    y2: 19.7411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayMarketLabelWhite);
export default __webpack_public_path__ + "static/media/PlayMarketLabelWhite.23d1e41dbf641598fab048c9ae146fc7.svg";
export { ForwardRef as ReactComponent };